export enum EExpertFrom {
    SCHOOL = "school",
};

export enum EExpertChatSource {
    USER = "user",
    EXPERT = "expert",
};

export enum EExpertConversationStatus {
    OPEN = "open",
    CLOSED = "closed",
};

export enum EChatAiResponseStatus {
    ACTIVE = "active",
    DISCARDED = "discarded",
};

export enum EResponseSourceType {
    LINK = 'link',
    PDF = 'pdf',
    DOCX = 'docx',
    IMAGE = 'image'
};

export enum EAssetMetaSourceType {
    LINK = 'link',
    DOCUMENT = 'document',
};

export enum EAssetMetaType {
    PASSPORT = 'passport',
    PERMIT = 'permit',
    VISA = 'visa',
};

export interface IExpertChat {
    id: number;
    expert_conversation_id: number;
    source: EExpertChatSource;
    message: string;
    created_at: Date;
};

export interface IExpertConversation {
    id: number;
    instance_id: number;
    title: string;
    status: EExpertConversationStatus;
    expert_from: EExpertFrom;
    created_at: Date;
    updated_at: Date;
    expert_chats: IExpertChat[];
};

export interface IExpertConversationForUser extends IExpertConversation {
    student_id: number;
    student_name: string;
};

export interface ICreateExpertChat extends Omit<IExpertChat, 'id' | 'created_at'> { };

export interface IResponseSource {
    id: number;
    chat_ai_response_id: number;
    type: EResponseSourceType;
    data: string;
    asset_meta: IAssetMeta | null;
};

export interface IAssetMeta {
    asset_id: number;
    name: string;
    url: string;
    type: EAssetMetaType;
    source_type: EAssetMetaSourceType;
};

export interface IChatAiResponse {
    id: number;
    response: string;
    confidence_score: number;
    rating: number | null;
    status: EChatAiResponseStatus;
    response_sources: IResponseSource[];
};

export interface IExpertConversationWithChats extends IExpertConversation {
    expert_chats: IExpertChat[];
};

export interface IExpertConversationWithChatsForUser extends IExpertConversationWithChats {
    student_id: number;
    student_name: string;
};

export interface ICreateExpertConversation extends Omit<IExpertConversation, 'id' | 'created_at' | 'instance_id' | 'updated_at' | 'expert_chats'> { };